var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "800px",
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        "destroy-on-close": "",
        "append-to-body": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("stores::products-info::sale_manager")) + " "
        ),
      ]),
      _c(
        "div",
        { staticClass: "detail" },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "16px",
                "font-weight": "bold",
                "margin-bottom": "20px",
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("stores::products-info::goods_info")) + " "
              ),
            ]
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { staticClass: "detail-item", attrs: { span: 8 } }, [
                _c("span", [
                  _c("label", [_vm._v("SPU:")]),
                  _vm._v(" " + _vm._s(_vm.product.spuId) + " "),
                ]),
              ]),
              _c(
                "el-col",
                { staticClass: "detail-item", attrs: { span: 16 } },
                [
                  _c("span", [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("stores::products-info::name")) + ":"
                      ),
                    ]),
                    _vm._v(" " + _vm._s(_vm.product.title) + " "),
                  ]),
                ]
              ),
              _c("el-col", { staticClass: "detail-item", attrs: { span: 8 } }, [
                _c("span", [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.$t("stores::products-info::category")) + ":"
                    ),
                  ]),
                  _vm._v(" " + _vm._s(_vm.product.categoryNames) + " "),
                ]),
              ]),
              _c(
                "el-col",
                { staticClass: "detail-item", attrs: { span: 16 } },
                [
                  _c("span", [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("system::responsible::供应商")) + ":"
                      ),
                    ]),
                    _vm._v(" " + _vm._s(_vm.product.supplier) + " "),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.getSalesList },
          model: {
            value: _vm.published,
            callback: function ($$v) {
              _vm.published = $$v
            },
            expression: "published",
          },
        },
        [
          _c("el-tab-pane", {
            attrs: {
              label: _vm.$t("stores::products-info::had_release"),
              name: "1",
            },
          }),
          _c("el-tab-pane", {
            attrs: {
              label: _vm.$t("stores::products-info::not_release"),
              name: "0",
            },
          }),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticStyle: { "margin-bottom": "10px" },
          attrs: {
            type: "primary",
            disabled:
              _vm.dialogTableSelection.length === 0 ||
              _vm.dialogTableSelection.some(function (item) {
                return item.publishStatus === 1 || item.publishStatus === 2
              }),
            loading: _vm.publishLoading,
          },
          on: { click: _vm.batchPublish },
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("stores::products-info::batch_had_release")) +
              " "
          ),
        ]
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.sellManagementLoading,
              expression: "sellManagementLoading",
            },
          ],
          attrs: { data: _vm.sellTableData, "max-height": "240px" },
          on: { "selection-change": _vm.dialogTableSelectChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", selectable: _vm.checkselect },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("stores::products-info::store"),
              prop: "shopName",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("stores::products-info::status"),
              prop: "status",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("stores::products-info::sale_status")) +
                          ": " +
                          _vm._s(
                            row.saleStatus
                              ? _vm.$t("stores::products-info::is_sale")
                              : _vm.$t("stores::products-info::stop_sale")
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("stores::products-info::release_status")
                          ) +
                          ": " +
                          _vm._s(_vm.getPublishStatus(row.publishStatus)) +
                          " "
                      ),
                      row.publishStatus === 3
                        ? _c("i", {
                            staticClass: "el-icon-warning-outline",
                            staticStyle: { color: "red" },
                          })
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("stores::products-info::operate") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled: [1, 2].includes(row.publishStatus),
                          loading: row.saleLoading === "pub",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.dialogPublish(row, "pub")
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("stores::products-info::release")) +
                            " "
                        ),
                      ]
                    ),
                    _vm.published === "1"
                      ? [
                          row.saleStatus
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    loading: row.saleLoading === "stop",
                                    disabled: [0, 1].includes(
                                      row.publishStatus
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.dialogStopSales(row, "stop")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "stores::products-info::stop_sale"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    loading: row.saleLoading === "start",
                                    disabled: [0, 1].includes(
                                      row.publishStatus
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.dialogSales(row, "start")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("stores::products-info::is_sale")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                        ]
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }